import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const AbortionIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <mask x="0.01" y="-0.06" width="24.45" height="24.45" />
      <path d="M16.31,14.21a1,1,0,0,1-1-1,1,1,0,0,1,1-1h6.11a1,1,0,0,1,1,1,1,1,0,0,1-1,1ZM1,8.58A5.47,5.47,0,0,1,6.63,3a5.87,5.87,0,0,1,2.52.56,6,6,0,0,1,2.07,1.58A6,6,0,0,1,15.8,3a5.61,5.61,0,0,1,4,1.58,5.16,5.16,0,0,1,1.67,3.9v.29a1.5,1.5,0,0,1,0,.29,1,1,0,0,1-.41.85,1.11,1.11,0,0,1-.75.21,1.19,1.19,0,0,1-.7-.32.81.81,0,0,1-.25-.74c0-.1,0-.2,0-.29a2.83,2.83,0,0,0,0-.29A3.21,3.21,0,0,0,18.32,6,3.5,3.5,0,0,0,15.8,5a3.73,3.73,0,0,0-2.14.66A7,7,0,0,0,12,7.33a.66.66,0,0,1-.33.29,1.07,1.07,0,0,1-.43.09,1,1,0,0,1-.44-.1,1,1,0,0,1-.33-.28A6.67,6.67,0,0,0,8.77,5.7,3.71,3.71,0,0,0,6.63,5,3.54,3.54,0,0,0,4.12,6,3.37,3.37,0,0,0,3.07,8.58a4.54,4.54,0,0,0,.35,1.7,8.49,8.49,0,0,0,1.28,2,29.22,29.22,0,0,0,2.49,2.65q1.59,1.52,4,3.66l2.26-2a1,1,0,0,1,.72-.26,1,1,0,0,1,.68.31,1,1,0,0,1,.3.75,1,1,0,0,1-.35.73l-2.26,2a1.81,1.81,0,0,1-.64.38,2,2,0,0,1-.71.13,2,2,0,0,1-.72-.13,1.6,1.6,0,0,1-.63-.41c-.77-.68-1.65-1.45-2.66-2.31A34.55,34.55,0,0,1,4.32,15,18.08,18.08,0,0,1,2,11.89,6.47,6.47,0,0,1,1,8.58Z" />
    </SvgIcon>
  )
}
export default AbortionIcon
